export enum ActivityType {
    CREATE = 'CREATE',
    UPDATE = 'UPDATE',
    UPDATE_DATA = 'UPDATE_DATA',
    STATE_UPDATE = 'STATE_UPDATE',
    ADD_COMMENT = 'ADD_COMMENT',
    DELETE = 'DELETE',
    PLANNED = 'PLANNED',
    PLANNED_CONFIRMED = 'PLANNED_CONFIRMED',
    MANUAL_FINISHED = 'MANUAL_FINISHED',
    QUOTE_CREATED = 'QUOTE_CREATED',
    QUOTE_UPDATED = 'QUOTE_UPDATED',
    QUOTE__STATE_UPDATED = 'QUOTE__STATE_UPDATED',
    QUOTE_MAIL_SEND = 'QUOTE_MAIL_SEND',
    QUOTE_MAIL_FAILED = 'QUOTE_MAIL_FAILED',
    QUOTE_CANCELLED = 'QUOTE_CANCELLED',
    QUOTE_RATED = 'QUOTE_RATED',
    VISIT_REPORT_UPDATED = 'VISIT_REPORT_UPDATED',
    PLANNING_ITEM_FEEDBACK_MAIL_SEND = 'PLANNING_ITEM_FEEDBACK_MAIL_SEND',
    PLANNING_ITEM_FEEDBACK_MAIL_FAILED = 'PLANNING_ITEM_FEEDBACK_MAIL_FAILED',
    PLANNING_ITEM_PLANNED_MAIL_SEND = 'PLANNING_ITEM_PLANNED_MAIL_SEND',
    PLANNING_ITEM_PLANNED_MAIL_FAILED = 'PLANNING_ITEM_PLANNED_MAIL_FAILED',
    PLANNING_ITEM_UPCOMING_MAIL_SEND = 'PLANNING_ITEM_UPCOMING_MAIL_SEND',
    PLANNING_ITEM_UPCOMING_MAIL_FAILED = 'PLANNING_ITEM_UPCOMING_MAIL_FAILED',
    PLANNED_NOTIFICATION_MAIL_SEND = 'PLANNED_NOTIFICATION_MAIL_SEND',
    PLANNED_NOTIFICATION_MAIL_FAILED = 'PLANNED_NOTIFICATION_MAIL_FAILED',
    LEAD_VIEWED = 'LEAD_VIEWED',
    PROTEST_LEAD = 'PROTEST_LEAD',
    LEAD_REOPENED = 'LEAD_REOPENED',
    UPDATE_LEAD_DATA = 'UPDATE_LEAD_DATA',
    NEW_LEAD = 'NEW_LEAD',
    RAW_LEAD = 'RAW_LEAD',
    LEAD_SOURCE_UNKNOWN = 'LEAD_SOURCE_UNKNOWN',
    LEAD_FEEDBACK_SENT = 'LEAD_FEEDBACK_SENT',
    LEAD_FEEDBACK_FAILED = 'LEAD_FEEDBACK_FAILED',
    LEAD_FEEDBACK_SKIPPED = 'LEAD_FEEDBACK_SKIPPED',
    LEAD_TRANSFORMED_TO_CLIENT = 'LEAD_TRANSFORMED_TO_CLIENT',
    MAINTENANCE_INACTIVE = 'MAINTENANCE_INACTIVE',
    MAINTENANCE_ACTIVE = 'MAINTENANCE_ACTIVE',
    CLIENT_UPDATE = 'CLIENT_UPDATE',
    CLIENT_EMAIL_WRONG_DATA_UPDATE = 'CLIENT_EMAIL_WRONG_DATA_UPDATE',
    ADD_CLIENT = 'ADD_CLIENT',
    ADD_CLIENT_THROUGH_PORTAL = 'ADD_CLIENT_THROUGH_PORTAL',
    ADD_CLIENT_THROUGH_SYNC_EXACT = 'ADD_CLIENT_THROUGH_SYNC_EXACT',
    ADD_PRODUCT = 'ADD_PRODUCT',
    PRODUCT_UPDATE = 'PRODUCT_UPDATE',
    ATTACHMENT_ADDED = 'ATTACHMENT_ADDED',
    ATTACHMENT_DELETED = 'ATTACHMENT_DELETED',
    MAINTENANCE_CREATED_FOR_NEW_LEAD = 'MAINTENANCE_CREATED_FOR_NEW_LEAD',
    UPDATE_WATER_METER_STAND = 'UPDATE_WATER_METER_STAND',
    WORK_ORDER_STATE_UPDATED = 'WORK_ORDER_STATE_UPDATED',
    WORK_ORDER_UPDATED = 'WORK_ORDER_UPDATED',
    WORK_ORDER_CREATED = 'WORK_ORDER_CREATED',
    WORK_ORDER_CANCELLED = 'WORK_ORDER_CANCELLED',
    ADD_DELIVERY_ADDRESS = 'ADD_DELIVERY_ADDRESS',
    UPDATE_PLANNINGITEM_DESCRIPTION = 'UPDATE_PLANNINGITEM_DESCRIPTION',
    QUOTE_MAIL_APPROVED_SEND = 'QUOTE_MAIL_APPROVED_SEND',
    QUOTE_MAIL_APPROVED_FAILED = 'QUOTE_MAIL_APPROVED_FAILED',
    SET_USER_TO_PLANNING_ITEM = 'SET_USER_TO_PLANNING_ITEM',
    ADD_LEAD_COST = 'ADD_LEAD_COST',
    UPDATE_LEAD_COST = 'UPDATE_LEAD_COST',
    DELETE_LEAD_COST = 'DELETE_LEAD_COST',
    MOVETEX_PLANNING_ITEM_CREATED = 'MOVETEX_PLANNING_ITEM_CREATED',
    MOVETEX_PLANNING_ITEM_UPDATED = 'MOVETEX_PLANNING_ITEM_UPDATED',
    MOVETEX_PLANNING_ITEM_REACTIVATED = 'MOVETEX_PLANNING_ITEM_REACTIVATED',
    UPDATE_PLANNINGITEM_DELIVERY_ADDRESS = 'UPDATE_PLANNINGITEM_DELIVERY_ADDRESS',
    MOVETEX_PLANNING_ITEM_ERROR = 'MOVETEX_PLANNING_ITEM_ERROR',
    MOVETEX_PLANNING_ITEM_DELETED = 'MOVETEX_PLANNING_ITEM_DELETED',
    MOVETEX_WEBHOOK_PLANNING_CHANGED = 'MOVETEX_WEBHOOK_PLANNING_CHANGED',
    MOVETEX_WEBHOOK_PLANNING_ACCEPTED = 'MOVETEX_WEBHOOK_PLANNING_ACCEPTED',
    MOVETEX_WEBHOOK_PLANNING_CANCELLED = 'MOVETEX_WEBHOOK_PLANNING_CANCELLED',
    MOVETEX_WEBHOOK_DUPLICATE_SKIPPED = 'MOVETEX_WEBHOOK_DUPLICATE_SKIPPED',
    MOVETEX_WEBHOOK_TERMINAL_STATE_SKIPPED = 'MOVETEX_WEBHOOK_TERMINAL_STATE_SKIPPED',
    MAINTENANCE_CANCELLED = 'MAINTENANCE_CANCELLED',
    MAINTENANCE_AUTO_CREATED_BY_SCHEDULER = 'MAINTENANCE_AUTO_CREATED_BY_SCHEDULER',
    MAINTENANCE_CONFIG_CREATED = 'MAINTENANCE_CONFIG_CREATED',
    MAINTENANCE_CONFIG_UPDATED = 'MAINTENANCE_CONFIG_UPDATED',
    MAINTENANCE_CONFIG_DELETED = 'MAINTENANCE_CONFIG_DELETED',
    TENANT_SETTINGS_UPDATED = 'TENANT_SETTINGS_UPDATED',
    CALENDAR_EVENT_UPDATED = 'CALENDAR_EVENT_UPDATED',
    CLIENT_EXACT_SYNCED = 'CLIENT_EXACT_SYNCED',
    CLIENT_EXACT_SYNC_FAILED = 'CLIENT_EXACT_SYNC_FAILED',
    EXACT_TOKEN_ERROR = 'EXACT_TOKEN_ERROR',
    EXACT_SYNC_ABORTED = 'EXACT_SYNC_ABORTED',
    EXACT_SYNC_RECOVERED = 'EXACT_SYNC_RECOVERED',
}
